export const currencyOptions = [
    {
        value: 'RON',
        label: 'RON'
    },
    {
        value: 'EUR',
        label: 'EUR'
    },
    {
        value: 'GBP',
        label: 'GBP'
    },
    {
        value: 'USD',
        label: 'USD'
    },
    {
        value: 'CHF',
        label: 'CHF'
    },
    {
        value: 'HUF',
        label: 'HUF'
    },
    {
        value: 'ISK',
        label: 'ISK'
    },
    {
        value: 'MDL',
        label: 'MDL'
    },
    {
        value: 'RSD',
        label: 'RSD'
    },
    {
        value: 'SEK',
        label: 'SEK'
    },
    {
        value: 'NOK',
        label: 'NOK'
    },
    {
        value: 'PLN',
        label: 'PLN'
    },
    {
        value: 'RUB',
        label: 'RUB'
    },
    {
        value: 'UAH',
        label: 'UAH'
    },
    {
        value: 'MXN',
        label: 'MXN'
    },
]

export const measuringUnits = [
    {
        value: 'cm',
        label: 'cm'
    },
    {
        value: 'inch',
        label: 'inch'
    },
]

export const qrCodeProxyURLStory = 'https://app.indexar.tech/story/'
export const qrCodeProxyURLProduct = 'https://app.indexar.tech/product/'


// WEBPACK FOOTER //
// ./src/lib/data.js